import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  showBusinessName: attr(Boolean),
  showImages: attr(Boolean),
  secondsPerImage: attr(Number)
});